module.exports = __webpack_public_path__ + "img/mc.cc974899.jpg";